import { Container } from "@peracto/peracto-blocks-tailwind";

import Accordion from "./Accordion";
import Carousel from "./Carousel";
import InfoPanels from "./InfoPanels";
import Products from "./Products";
import MenuItemsCarousel from "./MenuItemsCarousel";

import Hero from "./Hero";
import USPBlock from "./USPBlock";
import ImageAndText from "./ImageAndText";
import InfoPanel from "./InfoPanel";
import Reviews from "./Reviews";
import PanelGrid from "./PanelGrid";

export default {
    plugins: {
        content: [
            Carousel,
            Accordion,
            InfoPanels,
            Products,
            MenuItemsCarousel,
            Hero,
            USPBlock,
            ImageAndText,
            InfoPanel,
            Reviews,
            PanelGrid,
        ],
        layout: [Container],
    },
};
